import ProductConfiguratorValue from "../models/ProductConfigurator.Value";
export default class ProductConfigurator {
    // #region Properties
    groups = [];
    scopes = [];
    summary = [];
    product;
    item;
    hasConfiguration = false;
    selectedScope;
    // #endregion    
    // #region Boostrap
    SetProduct(product, summary) {
        // #region System
        this.product = product;
        this.summary = summary;
        this.scopes = [];
        // #endregion
        // #region Scopes
        if (!utils.isNullOrEmpty(product) && product.configuration && product.configuration.scopes) {
            //Set
            this.scopes = product.configuration.scopes;
            //Default
            if (!utils.isNullOrEmpty(product.configuration.defaultScope)) {
                this.selectedScope = product.configuration.defaultScope;
            }
            else if (this.scopes.length > 0) {
                this.selectedScope = this.scopes[0].name;
            }
            else {
                this.selectedScope = undefined;
            }
        }
        // #endregion
        // #region Groups
        this.buildGroups(false);
        // #endregion
        // #region Data
        this.hasConfiguration = this.groups.length > 0 && (product?.isReal ?? false);
        // #endregion
    }
    buildGroups(remberSelection) {
        // #region Remember
        let tSelectedValues = [];
        if (remberSelection) {
            this.groups.forEach(e => {
                e.values.forEach(v => {
                    if (v.selected) {
                        tSelectedValues.push(v);
                    }
                });
            });
        }
        // #endregion
        // #region Reset
        this.groups = [];
        // #endregion
        // #region Groups
        if (!utils.isNullOrEmpty(this.product) && this.product.configuration && this.product.configuration.groups) {
            var tIndex = 0;
            this.product.configuration.groups.forEach((e) => {
                //Option
                let tItem = {
                    name: e.selectionID,
                    caption: e.caption,
                    infoLink: e.infoLink,
                    allowMultible: false,
                    isSelection: e.isSelection,
                    controlType: e.controlType,
                    member: e.member,
                    index: tIndex,
                    currentValue: null,
                    currentValues: [],
                    values: [],
                };
                //Items
                tItem.values = this.getValues(tItem, e.values, tSelectedValues);
                if (tItem.values.length > 0) {
                    //Append
                    this.groups.push(tItem);
                    //Next
                    tIndex = tIndex + 1;
                }
            });
        }
        // #endregion
    }
    setItem(product) {
        // #region Set
        this.item = product;
        // #endregion
        // #region Core
        this.buildGroups(false);
        this.rebuildSummary();
        // #endregion
        // #region Update
        this.hasConfiguration = this.groups.length > 0 && (product?.isReal ?? false);
        // #endregion
    }
    setScope(name) {
        // #region Set
        this.selectedScope = name;
        // #endregion
        // #region Core
        this.buildGroups(true);
        this.rebuildSummary();
        // #endregion
        // #region Update
        this.hasConfiguration = this.groups.length > 0 && (this.item?.isReal ?? false);
        // #endregion
    }
    // #endregion    
    // #region Core
    OnValueChanged(group, Value, OldValue, NewValue) {
        // #region Uncheck
        if (!utils.isNullOrEmpty(Value.selectionGroup)) {
            group.values.forEach(e => {
                if (Value.selectionGroup === e.selectionGroup && e.valueID !== Value.valueID) {
                    e.setSelected(false);
                }
            });
        }
        // #endregion
        // #region Summary
        this.rebuildSummary();
        // #endregion
    }
    OnEntryValueChanged(group, Value, NewValue) {
        //Data
        var tField = this.summary.find(e => e.valueID === Value.valueID);
        //Set
        if (tField) {
            tField.entryValue1 = Value.entryValue;
        }
    }
    // #endregion
    // #region Internal
    getValues(group, arg0, selectedValues) {
        //New
        var tdata = new Array();
        //Fill
        arg0.forEach((e) => {
            if (this.scopes.length > 0) {
                if (e.scopes && e.scopes.length > 0 && !e.scopes.some(f => f == this.selectedScope)) {
                    return;
                }
            }
            let tOption = e.options.find(e => e.itemNumbers.some(f => f == this.item?.itemNumber || e.itemNumbers.length === 0));
            {
                if (!tOption) {
                    return;
                }
            }
            //Value
            let tValue = new ProductConfiguratorValue(this, group, {
                valueID: e.valueID,
                optionID: tOption.optionID,
                optionNumber: tOption.optionNumber,
                selectionGroup: e.selectionGroup,
                priceMode: e.priceMode,
                scopes: e.scopes,
                caption: e.caption,
                description: e.description,
                infoLink: e.infoLink,
                actAsRadio: e.actAsRadio,
                isDefault: e.isDefault,
                selected: selectedValues.some(f => f.valueID == e.valueID) || (e.actAsRadio && e.isDefault && !this.hasGroupSelection(arg0, e.selectionGroup, selectedValues)),
                disabled: false,
                possible: true,
                entryValue: selectedValues.find(f => f.valueID == e.valueID)?.entryValue,
                entryField: e.entryField,
                deliveryTime: e.deliveryTime
            });
            //Preise
            if (e.priceMode == 2) {
                let tPrice2 = this.item.configurations.find(e => e.valueID === tValue.valueID && e.optionID === tValue.optionID);
                {
                    if (!tPrice2) {
                        return;
                    }
                }
                tValue.price = tPrice2.price;
                tValue.priceFormated = tPrice2.priceFormated;
            }
            else {
                tValue.price = tOption.price;
                tValue.priceFormated = tOption.priceFormated;
            }
            //Add
            tdata.push(tValue);
        });
        return tdata;
    }
    hasGroupSelection(arg0, selectionGroup, selectedValues) {
        if (utils.isNullOrEmpty(selectionGroup)) {
            return false;
        }
        let tHasValue = false;
        arg0.filter(e => e.selectionGroup === selectionGroup).forEach(e => {
            if (selectedValues.some(f => f.valueID == e.valueID)) {
                tHasValue = true;
            }
        });
        return tHasValue;
    }
    rebuildSummary() {
        // #region Clear
        while (this.summary.length) {
            this.summary.pop();
        }
        // #endregion
        // #region Build
        this.groups.forEach(g => {
            g.values.forEach(v => {
                if (!v.selected) {
                    return;
                }
                this.summary.push({
                    groupID: g.name,
                    valueID: v.valueID,
                    optionID: v.optionID,
                    caption: v.caption,
                    itemNumber: v.optionNumber,
                    entryValue1: v.entryValue,
                    deliveryTime: v.deliveryTime,
                    price: v.price,
                    priceFormated: v.priceFormated,
                });
            });
        });
        // #endregion     
    }
}
